/**
 * Responsável pela funcionalidade de menu do grid de survey.
 * @author: adalto.junior
 * Date: 31/01/14
 * Time: 09:17
 */



Greenmile.Survey = Greenmile.Survey || {};
Greenmile.Survey.Grid = Greenmile.Survey.Grid || {};

Greenmile.Survey.Grid.Menu = (function () {

    function Menu () {

        Greenmile.Grid.Menu.apply(this, arguments);

        var actionGridMenu = {
            RELEASE: 'btn_release_survey_menu',
            CLOSE: 'btn_close_survey_menu'
        };

        this.getItemsToMenu = function (survey) {

            var items = [],
                releaseSurvey,
                closeSurvey,
                cloneSurvey,
                gridMenu,
                enabledMenus,
                urlRelease,
                urlClose,
                urlClone;

            gridMenu = this.gridMenu;
            enabledMenus = this.getEnabledMenu();

            var releasedDate = survey.get('releasedDate');
            var closedDate = survey.get('closedDate');
            var surveyId = survey.get('id');

            var removeLoading = function () {

                var loading = document.getElementById('loading_img');

                if (loading) {
                    loading.style.display = 'none';
                }

            };

            var requestActionToSurvey = function (url) {

                var request = new Monet.Ajax();
                request.success = function () {

                    removeLoading();

                    var filter = App.Objects.Survey.getFilter();

                    Monet.Grid.Utils.clearPagination('Survey');
                    App.Objects.Survey.updateGrid(filter, Monet.Grid.addDataToGrid, false);

                };

                request.error = function (xhr) {

                    Monet.Configurations.errorNotification(null, xhr, null, null);
                    removeLoading();


                };

                request.url = url;

                var loading = document.getElementById('loading_img');

                if (loading) {
                    loading.style.display = 'block';
                }

                request.send();

                gridMenu.removeAllMenus();

            };

            urlRelease = 'Survey/' + surveyId + '/Release';
            urlClose = 'Survey/' + surveyId + '/Close';
            urlClone = "Survey/" + surveyId + "/Clone";

            releaseSurvey = {
                id: 1,
                description: Monet.I18n.getResourcesByKey('Survey.GridMenu.releaseSurvey'),
                icon: '',
                action: function () {

                    const question   = Monet.I18n.getResourcesByKey('survey.grid.release') + ' ' + survey.attributes.title;

                    const confirmIsToDelete = () => {
                        requestActionToSurvey(urlRelease);
                    };

                    new Greenmile.Components.AlertModal(question,
                        null,
                        confirmIsToDelete)
                    .show();

                }
            };

            closeSurvey = {
                id: 2,
                description: Monet.I18n.getResourcesByKey('Survey.GridMenu.closeSurvey'),
                icon: '',
                action: function () {

                    const question   = Monet.I18n.getResourcesByKey('survey.grid.close') + ' ' + survey.attributes.title;

                    const confirmToClose = () => {
                        requestActionToSurvey(urlClose);
                    };

                    new Greenmile.Components.AlertModal(question,
                        null,
                        confirmToClose)
                    .show();

                }
            };

            cloneSurvey = {
                id: 2,
                description: Monet.I18n.getResourcesByKey("Survey.GridMenu.cloneSurvey"),
                icon: "",
                action: function () {
                    const question  = Monet.I18n.getResourcesByKey("survey.grid.clone") + " " + survey.attributes.title;

                    const confirmToClone = () => {
                        requestActionToSurvey(urlClone);
                    };

                    new Greenmile.Components.AlertModal(question,
                        null,
                        confirmToClone)
                    .show();
                }
            };

            if (!releasedDate && enabledMenus.isEnabled(actionGridMenu.RELEASE)) {

                items.push(releaseSurvey);

            } else if (releasedDate && !closedDate && enabledMenus.isEnabled(actionGridMenu.CLOSE)) {

                items.push(closeSurvey);

            }

            var reports = {
                id: 3,
                description: Monet.I18n.getResourcesByKey("Survey.GridMenu.reports"),
                icon: "",
                action: function () {
                    var reportTemplate = new Greenmile.Survey.ReportTemplate;
                    reportTemplate.setSurveyId(surveyId);
                    reportTemplate.fetchTemplates();
                }.bind(this)
            };

            items.push(reports);

            items.push(cloneSurvey);

            return items;

        };

    }

    return Menu;

}());
